import { BUCKET } from '@univacity/shared/types';

export class FileUtil {
  public static getBuketName(filename: string): BUCKET {
    filename = filename.replace('/', '');
    const index = filename.indexOf('___');

    const bucket = index < 0 ? BUCKET.private : filename.substring(0, index);
    return Object.values(BUCKET).includes(bucket as BUCKET)
      ? (bucket as BUCKET)
      : BUCKET.private;
  }
}
